import React, { useEffect, useState } from "react";
import { SignalPulse } from "../components/SignalPulse";
import { useNavigate } from "react-router-dom";
import { Bookmark } from "lucide-react";
import api, { CATEGORY_LABELS } from "../lib/api";
import { PostCard } from "./Feed";
import { useAuth } from "../context/AuthContext";

export default function Saved() {
  const [posts, setPosts] = useState(null);
  const [filter, setFilter] = useState("");
  const navigate = useNavigate();
  const { user } = useAuth();

  const load = async () => {
    const { data } = await api.get("/posts/saved");
    setPosts(data);
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const handleDelete = async (postId) => {
    if (!window.confirm("Permanently delete this transmission? This cannot be undone.")) return;
    const prev = posts;
    setPosts((p) => p.filter((x) => x.id !== postId));
    try { await api.delete(`/posts/${postId}`); }
    catch { setPosts(prev); alert("Could not delete the post. Please try again."); }
  };

  const handleUnsave = (postId) => setPosts((p) => p.filter((x) => x.id !== postId));

  const visible = posts ? (filter ? posts.filter((p) => p.category === filter) : posts) : null;
  const availableCats = posts ? [...new Set(posts.map((p) => p.category))] : [];

  return (
    <div className="max-w-2xl mx-auto px-4 md:px-6 py-8" data-testid="saved-page">
      <header className="mb-8">
        <h1 className="font-heading text-3xl font-medium tracking-tight text-[#14A89A]">Saved</h1>
        <p className="font-body text-sm text-zinc-500 mt-1">Signals you've kept for later, private to you.</p>
      </header>

      {posts && posts.length > 0 && availableCats.length > 1 && (
        <div className="flex gap-2 overflow-x-auto pb-3 mb-8 -mx-4 px-4 md:mx-0 md:px-0" data-testid="saved-category-filters">
          <button onClick={() => setFilter("")} data-testid="saved-filter-all" className={`shrink-0 px-4 py-2 font-body text-xs tracking-wider uppercase border transition-colors ${filter === "" ? "border-[#A855F7] text-[#A855F7]" : "border-white/15 text-zinc-400 hover:text-white"}`}>All</button>
          {availableCats.map((k) => (
            <button key={k} onClick={() => setFilter(k)} data-testid={`saved-filter-${k}`} className={`shrink-0 px-4 py-2 font-body text-xs tracking-wider uppercase border transition-colors ${filter === k ? "border-[#A855F7] text-[#A855F7]" : "border-white/15 text-zinc-400 hover:text-white"}`}>{CATEGORY_LABELS[k]}</button>
          ))}
        </div>
      )}

      {visible === null ? (
        <div className="flex justify-center py-20"><SignalPulse size={44} /></div>
      ) : posts.length === 0 ? (
        <div className="text-center py-20 border border-white/10" data-testid="saved-empty">
          <Bookmark className="mx-auto text-zinc-600 mb-4" strokeWidth={1.5} />
          <p className="font-heading text-xl text-white mb-2">Nothing saved yet</p>
          <p className="font-body text-sm text-zinc-500">Tap the bookmark on any signal to keep it here.</p>
        </div>
      ) : visible.length === 0 ? (
        <div className="text-center py-16 border border-white/10" data-testid="saved-filter-empty">
          <p className="font-body text-sm text-zinc-500">Nothing saved in this realm yet.</p>
        </div>
      ) : (
        <div className="flex flex-col gap-12">
          {visible.map((p) => (
            <PostCard key={p.id} post={p} onNav={navigate} onDelete={handleDelete} onUnsave={handleUnsave} allowNote currentUser={user} />
          ))}
        </div>
      )}
    </div>
  );
}
